<template>
  <div class="tasks-wrapper">
    <vuex-table :fields="fields" table_store="tasks/table" :tr_link="true">
      <template #state="{ item }">
        <tooltip
          placement="right"
          min-width="200"
          max-width="200"
          theme="light"
          :content="getTaskStatus(item.state, item.fail_cause)"
        >
          <template v-if="item.state === 'pending'">
            <icon size="18" :type="`md-time`" />
          </template>
          <template v-else-if="item.state === 'processing'">
            <icon size="18" type="ios-loading" />
          </template>
          <template v-else-if="item.state === 'autocaller'">
            <icon size="18" type="md-filing" />
          </template>
          <template v-else-if="item.state === 'completed'">
            <icon size="18" type="md-checkmark" class="icon-color-green" />
          </template>
          <template v-else-if="item.state === 'delayed'">
            <v-icon size="18" class="material-icons-outlined" color="#515A6E">
              mdi-clock-alert
            </v-icon>
          </template>

          <template v-else>
            <icon size="18" type="md-close" class="icon-color-red" />
          </template>
        </tooltip>
      </template>

      <template #assigned_to="{ item }">
        <assigned :id="item.assigned_to" />
      </template>

      <template slot="actions" slot-scope="{ item }">
        <template v-if="user.role !== 'user'">
          <table-control type="edit" @click="edit(item)" />
        </template>
      </template>
    </vuex-table>
  </div>
</template>

<script>
  import Assigned from '@tasks/components/tasks/assigned';
  import { StatusesService } from '@administration/services/StatusesService';
  import { mapGetters, mapActions } from 'vuex';
  import i18n from '@/plugins/i18n';

  export default {
    components: {
      Assigned
    },
    data: () => ({
      statesList: {}
    }),

    computed: {
      ...mapGetters('core/auth', ['user']),
      fields() {
        return [
          {
            key: 'state',
            label: '',
            class: 'text-left',
            thStyle: { width: '100px' }
          },
          {
            key: 'project.name',
            label: this.$t('tasks.table.project'),
            thStyle: { width: '200px' }
          },
          {
            key: 'customer_name',
            label: this.$t('tasks.table.full_name'),
            thStyle: { width: '100px' }
          },
          {
            key: 'customer_phone',
            label: this.$t('tasks.table.phone'),
            thStyle: { width: '140px' }
          },
          {
            key: 'customer_email',
            label: this.$t('tasks.table.email'),
            thStyle: { width: '200px' }
          },
          {
            key: 'assigned_to',
            label: this.$t('tasks.table.executor'),
            thStyle: { width: '130px' }
          },
          {
            key: 'task_state_id',
            label: this.$t('tasks.table.status'),
            thStyle: { width: '130px' },
            formatter: (value) => this.getStatus(value)
          },
          {
            key: 'created_at',
            label: this.$t('tasks.table.create_at')
          },
          {
            key: 'updated_at',
            label: this.$t('tasks.table.updated_at')
          },
          {
            key: 'actions',
            label: '',
            class: 'text-right',
            thStyle: { width: '110px' }
          }
        ];
      }
    },

    async mounted() {
      await StatusesService.getList().then((resp) => (this.statesList = resp.data));
    },
    beforeDestroy() {
      this.getAsyncData();
    },
    methods: {
      ...mapActions('tasks/table', ['getAsyncData']),
      getTaskStatus(status, cause) {
        if (status === 'failed') {
          return i18n.t(`tasks.fail_causes.${cause}`);
        }
        return i18n.t(`tasks.statuses.${status}`);
      },
      edit(item) {
        this.$router.push({
          name: 'tasks.edit',
          params: { id: item.id, edit: true, allow_call: false }
        });
      },

      getStatus(id) {
        const status = this.$R.compose(
          this.$R.pathOr('', ['name']),
          this.$R.find(this.$R.propEq('id', id))
        )(this.statesList);

        return status;
      }
    }
  };
</script>

<style lang="scss">
  .tasks-wrapper tbody tr {
    cursor: pointer;
  }
  .icon-color {
    &-green {
      color: #28d094;
    }
    &-red {
      color: #c01128;
    }
  }
</style>
